/**
 * Dark/Light Mode Toggle Component
 *
 * @changeHistory
 * - 2025-12-06: Initial creation (AI Agent)
 */

import { JSX } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@shared/components/ui/button';
import { useTheme } from '@shared/components/ThemeProvider';

export const ModeToggle = ({ className }: { className?: string }): JSX.Element => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = (): void => {
    // Cycle: light -> dark -> light (ignoring system for simple toggle, or light->dark?)
    // Figma usually implies a binary switch.
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <Button variant="ghost" size="icon" onClick={toggleTheme} className={className}>
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};
